<div>
    @if(showPrivatePersonForm()) {
        <form [formGroup]="searchPersonForm">
            <div class="row">
                <div class="col">
                    <label for="credit-safe-info-fetcher-input">Personnummer</label>
                    <input
                            type="text"
                            class="form-control"
                            id="credit-safe-info-fetcher-input"
                            placeholder="Ange 10-siffrigt personnummer - XXXXXYYYY"
                            formControlName="personalNumberToSearch"
                            [class.is-invalid]="searchPersonForm.get('personalNumberToSearch')?.invalid && searchPersonForm.get('personalNumberToSearch')?.touched"
                    />
                    <div class="invalid-feedback" *ngIf="searchPersonForm.get('personalNumberToSearch')?.invalid && searchPersonForm.get('personalNumberToSearch')?.touched">
                        @if (!searchPersonForm.get('personalNumberToSearch')?.value) {
                            Personnummer är obligatoriskt.
                        } @else {
                            Ogiltigt personnummer.
                        }
                    </div>
                </div>
                <div class="col-auto" style="padding-top: 1.6rem;">
                    <button
                            type="button"
                            class="btn btn-primary"
                            (click)="getPrivatePersonInformation()"
                            [disabled]="isLoading || searchPersonForm.invalid"
                    >
                    <span
                            class="spinner-border spinner-border-sm me-1"
                            *ngIf="isLoading"
                    ></span>
                        Hämta uppgifter
                    </button>
                </div>
            </div>
        </form>
    }

    @if(showOrganizationForm()) {
        <form [formGroup]="searchOrganizationForm">
            <div class="row">
                <div class="col">
                    <label for="credit-safe-info-fetcher-input">Organisationnummer</label>
                    <input
                            type="text"
                            class="form-control"
                            id="credit-safe-info-fetcher-input"
                            placeholder="Ange 10-siffrigt organisationnummer - XXXXXYYYY"
                            formControlName="organizationNumberToSearch"
                            [class.is-invalid]="searchOrganizationForm.get('organizationNumberToSearch')?.invalid && searchOrganizationForm.get('organizationNumberToSearch')?.touched"
                    />
                    <div class="invalid-feedback" *ngIf="searchOrganizationForm.get('organizationNumberToSearch')?.invalid && searchOrganizationForm.get('organizationNumberToSearch')?.touched">
                        @if (!searchPersonForm.get('organizationNumberToSearch')?.value) {
                            Organisationnummer är obligatoriskt.
                        } @else {
                            Ogiltigt organisationnummer.
                        }
                    </div>
                </div>
                <div class="col-auto" style="padding-top: 1.6rem;">
                    <button
                            type="button"
                            class="btn btn-primary"
                            (click)="getOrganizationInformation()"
                            [disabled]="isLoading || searchOrganizationForm.invalid"
                    >
                    <span
                            class="spinner-border spinner-border-sm me-1"
                            *ngIf="isLoading"
                    ></span>
                        Hämta uppgifter
                    </button>
                </div>
            </div>
        </form>
    }

    <!-- Signatories Dropdown - Only visible after successful organization search -->
    @if (organizationSearchSuccessful && signatories.length > 0) {
        <div class="signatories-section mt-1">
            <div class="form-group">
                <label for="signatorySelect" class="form-label">Firmatecknare</label>
                <select
                        id="signatorySelect"
                        class="form-select"
                        [formControl]="signatorySelectionForm.get('selectedSignatory')"
                        (change)="onSignatoryChange()">
                    <option value="">-- Välj firmatecknare --</option>
                    @for (signatory of signatories; track signatory.value) {
                        <option [value]="signatory.value">{{ signatory.label }}</option>
                    }
                </select>
            </div>
        </div>
    }


    @if (organizationSearchSuccessful && signatories.length === 0) {
        <div class="alert alert-warning mt-1 p-1">
            Inga firmatecknare hittades.
        </div>
    }


</div>
